import {
    useMemo,
} from 'react'

import {
    ReactComponent as WarningIcon,
} from 'app/shared-components/images/icons/warning_icon.svg'
import {
    IconType,
} from 'app/enums/common.enums'

import TooltipWrapper from 'app/shared-components/Tooltip/TooltipWrapper'
import useStyles from './TextIcon.styles'

export default function TextIcon({
    type,
    value,
    tooltip,
}: Readonly<{
    type?: IconType,
    value: string,
    tooltip?: string,
}>) {
    const {
        classes, cx,
    } = useStyles({
        type,
    })
    const icon = useMemo(() => {
        switch (type) {
        case IconType.Warning:
            return <WarningIcon className={classes.icon} />
        default:
            return null
        }
    }, [
        classes.icon,
        type,
    ])

    return (
        <div className={classes.cell}>
            <div className={cx(classes.text, classes[type])}>{value}</div>
            <TooltipWrapper
                value={tooltip}
                ownTooltipProps={{
                    enterDelay: 100,
                    placement: 'bottom',
                }}
            >
                {icon}
            </TooltipWrapper>
        </div>
    )
}
